import * as React from "react";
import Abrams from "../src/assets/images/Abrams.png";
import SEG from "../src/assets/images/PROJECTS _ seg-inc.png";
import sales from "../src/assets/images/sales1.png";
import dashboard from "../src/assets/images/hand.png";
import TitleList from "../src/assets/images/Title-List.png";
import axios from "axios";
import AmazonIcon from "../src/assets/images/Amazonicon.png";
import DataHub from "../src/assets/images/DataHub.png";
import IPM from "../src/assets/images/IPM2.png";
import PartnerPortal from "../src/assets/images/PartnerPortal.png";
import Loading from "./Loader";

const App = () => {
  const [UrlData, setUrlData] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const reportIdMap = {
    COOP: "1",
    "Reporting & Analytics": "2",
    "Seasonal Estimate Grid": "3",
    Titles: "4",
    Amazon: "5",
    "Data Hub": "6",
    "IPM Royalties": "7",
    "Abrams BI": "8",
     "Amazon Ads": "10",
  };

  React.useEffect(() => {
    const fetchUrls = async () => {
      try {
        const payload = {
          env: process.env.REACT_APP_ENV,
          reportId: Object.values(reportIdMap),
        };

        const res = await axios.post(
          `${BASE_URL}/fetchUrlsForReports`,
          payload
        );
        console.log(res, "++++++++++++++");
        setUrlData(res.data.data);
      } catch (error) {
        console.error("Error fetching URLs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUrls();
  }, []);

  const tiles = [
    {
      title: "COOP",
      image: dashboard,
    },
    {
      title: "Reporting & Analytics",
      image: sales,
    },
    {
      title: "Seasonal Estimate Grid",
      image: SEG,
    },
    {
      title: "Titles",
      image: TitleList,
    },
    {
      title: "Amazon",
      image: AmazonIcon,
    },
    {
      title: "Data Hub",
      image: DataHub,
    },
    {
      title: "IPM Royalties",
      image: IPM,
    },
    {
      title: "Abrams BI",
      image: PartnerPortal,
    },
     {
      title: "Amazon Ads",
      image: AmazonIcon,
    },
  ];
  var BASE_URL = process.env.REACT_APP_BASE_URL;
  // filter UrlData by IS_ACTIVE === "TRUE"
  const activeUrlData = UrlData.filter((item) => item.IS_ACTIVE === "TRUE");

  // build filteredTiles using both search and IS_ACTIVE
  const filteredTiles = tiles
    .filter((tile) =>
      tile.title.toLowerCase().includes(searchTerm.toLowerCase().trim())
    )
    .filter((tile) => {
      const dynamicReport = activeUrlData.find(
        (data) => data.ID === reportIdMap[tile.title]
      );
      return !!dynamicReport;
    });

  return (
    <Loading isLoading={loading}>
      <main className=" w-screen flex flex-col font-poppins ">
        {/* <header className="w-full bg-gray-100 flex items-center justify-center"> */}
        <header className="w-full bg-gray-100 flex flex-col md:flex-row md:items-center md:justify-center ">
          {/* <div className="w-full ml-[220px] flex justify-center items-center"> */}
          <div className="flex justify-center sm:w-full sm:ml-[220px] items-center">
            <img src={Abrams} alt="Abrams" className="h-[60px] md:h-[90px]" />
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-end sm:w-[300px]  mx-2 p-1 px-4 gap-2">
            <div className="relative">
              <div className="absolute inset-y-0 left-2 flex items-center text-gray-500">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 512 512"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
                </svg>
              </div>
              <input
                type="text"
                placeholder="Find a report or application"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-[200px] p-2 pl-8   focus:ring-2md:px-8 md:py-2 px-6 py-2  rounded-lg border border-gray-300 focus:border-blue-500 focus:outline-none font-poppins focus:ring-blue-500"
              />
            </div>

            <button
              disabled={!searchTerm.length}
              onClick={() => setSearchTerm("")}
              className={`${
                !searchTerm.length
                  ? "bg-red-400 cursor-not-allowed"
                  : "bg-[#e31c23] cursor-pointer hover:bg-red-600 transition"
              } text-white px-4 py-2 rounded-md font-poppins text-[14px]`}
            >
              Clear
            </button>
          </div>
        </header>

        <div className="h-[82vh] overflow-y-auto">
          <div className="max-w-full  mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 md:px-8 py-6">
              {filteredTiles.length > 0 ? (
                filteredTiles.map((tile, idx) => {
                  const isLastOdd =
                    filteredTiles.length % 3 === 1 &&
                    idx === filteredTiles.length - 1;
                  const dynamicReport = activeUrlData.find(
                    (data) => data.ID === reportIdMap[tile.title]
                  );
                  const tileLink = tile.link || dynamicReport?.URL || "";

                  return (
                    <a
                      href={tileLink}
                      key={idx}
                      className={`block no-underline text-inherit bg-transparent 
           `}
                    >
                      <div
                        style={{ boxShadow: "0 8px 16px rgba(0, 0, 0, 0.5)" }}
                        className="relative h-[150px] md:h-[220px] w-full max-w-[450px] mx-auto cursor-pointer border border-red-500 
              bg-gray-100 text-[20px] md:text-[30px] font-medium py-2"
                      >
                        <div className="flex justify-center items-center mt-10 md:mt-12">
                          <img
                            src={tile.image}
                            alt={tile.title}
                            className={
                              tile.title === "COOP"
                                ? "w-14 sm:w-28 md:w-28 h-22"
                                : tile.title === "Amazon"
                                ? "sm:h-[100px] h-[60px] w-[120px] object-fit"
                                : tile.title === "Data Hub"
                                ? "sm:h-[110px] h-[80px] w-[220px]"
                                : tile.title === "IPM Royalties"
                                ? "sm:h-[110px] h-[80px] w-auto ipm_class ipmclass"
                                : tile.title === "Seasonal Estimate Grid"
                                ? "sm:h-[100px] h-[80px] w-auto "
                                : tile.title === "Reporting & Analytics"
                                ? "sm:h-[100px] h-[80px] w-auto "
                                : tile.title === "Titles"
                                ? "sm:h-[100px] h-[80px] w-auto "
                                : tile.title === "Abrams BI"
                                ? "sm:h-[130px] h-[80px] w-auto "
                                : "h-[100px]"
                            }
                          />
                        </div>
                        <div
                          className="bg-red-600 text-white text-[20px] md:text-[30px]
                flex items-center justify-center w-full absolute bottom-0"
                        >
                          {tile.title}
                        </div>
                      </div>
                    </a>
                  );
                })
              ) : (
                <div className="col-span-full flex justify-center items-center h-[60vh] text-gray-500 text-[14px]">
                  {loading ? "" : "No Record found"}
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <div className="">
        <div className="absolute bottom-[-40px] left-2 text-gray-400 text-[10px] md:text-[14px]">
          <span>Version </span> 1.1.3
        </div>
        <div className="absolute bottom-[-40px] right-4 md:text-[14px] text-[10px] text-gray-400">
          © {new Date().getFullYear()} ABRAMS
        </div>
      </div>
    </Loading>
  );
};

export default App;
